var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SupplierEmailsDialog',{attrs:{"show":_vm.show,"title":_vm.title,"subtitle":_vm.subtitle,"items":_vm.items,"event":_vm.emailEvent,"note":_vm.note},on:{"close":function($event){return _vm.$emit('close')},"sent":function($event){return _vm.$emit('sent', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }